import { render } from "./SocialMediaButton.vue?vue&type=template&id=9901a536&ts=true"
import script from "./SocialMediaButton.vue?vue&type=script&lang=ts"
export * from "./SocialMediaButton.vue?vue&type=script&lang=ts"

import "./SocialMediaButton.vue?vue&type=style&index=0&id=9901a536&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__